import React from 'react';
import API from "../../Services/BaseService";
import { useHistory } from "react-router-dom";
import { useState } from 'react';
import { useEffect } from 'react';
import Loading from "../../Component/Loading/Loading";
import localStorage from 'local-storage';
import { useSelector } from 'react-redux';
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import {
  Button
} from 'antd';
import PageNotFound from '../FallBackUI/PageNotFound';

const MeetStaff = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [managerInfo, setmanagerInfo] = useState([]);
  const [asstmangerInfo, setasstmangerInfo] = useState([]);
  const [executiveInfo, setexecutiveInfo] = useState([]);
  const [clerkInfo, setclerkInfo] = useState([]);
  const sellerDetails = localStorage.get("sellerDetails");
  const successData = useSelector(state => state.LoginReducer.payload);

  const [errors, setErrors] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);
  
  function fetchManagerDetails() {
    console.log("===JSON.parse(localStorage.getItem====>",localStorage.get("sellerDetails"))
   
    const state = API.post('meetStaff/condition');
    state.then(res => {
      console.log("res==data====>", res.data.data)
      console.log("Manager data",res.data.data[0]);
      // if( res.data.success){
        if (res.data.success === true) {
        setmanagerInfo(res.data.data);
        setasstmangerInfo(res.data.data);
        setexecutiveInfo(res.data.data);
        setclerkInfo(res.data.data);
        console.log("Manager state",managerInfo)
        setLoading(false);
      // }
    }
    else {
        setErrors(res.data.error)
        setErrorFlag(true)
    }
  }) .catch(function (error) {
    if (error.response) {
        setErrors(error.response.data.error)
        setErrorFlag(true)
        setLoading(false);
    }
});
  }


 
  useEffect(() => {
      fetchManagerDetails();
  }, []);

  return (
    <div>
      {loading?<Loading/>:
      <main id="main" className="inner-page">
        {errorFlag === true ? <PageNotFound error={errors} /> :
        <div id="mgaccount" className="mgaccount">
          <div className="container" >
          <div class="back-btn">
                  <a class="back-btn-primary" onClick={() => history.push("/carlist")}>
                    <i class="bx bx-chevron-left"></i> Back
                  </a>
                </div>
            <div className="mgaccountblock col-lg-12">
              <div className="section-title">
                <h2>Meet The Staff</h2>
              </div>
              <div className="row content">
                <div className="col-lg-12 col-md-12 col-sm-12 pt-4 pt-lg-0 mgaccountrightblock meetthesatff">
                <div className="row">
                  {managerInfo.length > 0 ? managerInfo.slice(0,1).map((item, index) =>
                    <div className="mgaccountrighttableblock mt-3  pt-4 col-lg-6">
                      <h3>Manager</h3>
                      <p>Lorem ipsum is simple dummy text Of the printing and typesetting industry</p>
                      <div className="mgaccountrighttable">
                        <table>
                          <thead></thead>
                          <tr>
                            <td><span class="tdcol1">Name</span><span>{item.name}</span></td>
                          </tr>
                          <tr>
                            <td><span class="tdcol1">Email</span><span>{item.email}</span></td>
                          </tr>
                          <tr>
                            <td><span class="tdcol1">Office #</span><span>{item.office}</span></td>
                          </tr>
                          <tr>
                            <td><span class="tdcol1">Cell #</span><span>{item.cell}</span></td>
                          </tr>
                          <tr>
                            <td><span class="tdcol1">Fax #</span><span>{item.fax}</span></td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  ) : ""}

                    {asstmangerInfo.length > 0 ? asstmangerInfo.slice(2,3).map((item, index) =>
                    <div className="mgaccountrighttableblock mt-3 pt-4 col-lg-6">
                      <h3>Assistant Manager</h3>
                      <p>Lorem ipsum is simple dummy text Of the printing and typesetting industry</p>
                      <div className="mgaccountrighttable">
                        <table>
                          <thead></thead>
                          <tr>
                            <td><span class="tdcol1">Name</span><span>{item.name}</span></td>
                          </tr>
                          <tr>
                            <td><span class="tdcol1">Email</span><span>{item.email}</span></td>
                          </tr>
                          <tr>
                            <td><span class="tdcol1">Office #</span><span>{item.office}</span></td>
                          </tr>
                          <tr>
                            <td><span class="tdcol1">Cell #</span><span>{item.cell}</span></td>
                          </tr>
                          <tr>
                            <td><span class="tdcol1">Fax #</span><span>{item.fax}</span></td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  ) : ""}

                  {executiveInfo.length > 0 ? executiveInfo.slice(1,2).map((item, index) =>
                    <div className="mgaccountrighttableblock mt-3 pt-4 col-lg-6">
                      <h3>Account Executive                       
                      </h3>
                      <p>Lorem ipsum is simple dummy text Of the printing and typesetting industry</p>
                      <div className="mgaccountrighttable">
                        <table>
                          <thead></thead>
                          <tr>
                            <td><span class="tdcol1">Name</span><span>{item.name}</span></td>
                          </tr>
                          <tr>
                            <td><span class="tdcol1">Email</span><span>{item.email}</span></td>
                          </tr>
                          <tr>
                            <td><span class="tdcol1">Office #</span><span>{item.office}</span></td>
                          </tr>
                          <tr>
                            <td><span class="tdcol1">Cell #</span><span>{item.cell}</span></td>
                          </tr>
                          <tr>
                            <td><span class="tdcol1">Fax #</span><span>{item.fax}</span></td>
                          </tr>
                        </table>
                       
                      </div>

                    </div>
                    ) : ""}

                   {clerkInfo.length > 0 ? clerkInfo.slice(3,4).map((item, index) =>
                    <div className="mgaccountrighttableblock mt-3 pt-4 col-lg-6">
                      <h3>Office Clerk                       
                      </h3>
                      <p>Lorem ipsum is simple dummy text Of the printing and typesetting industry</p>
                      <div className="mgaccountrighttable">
                        <table>
                          <thead></thead>
                          <tr>
                            <td><span class="tdcol1">Name</span><span>{item.name}</span></td>
                          </tr>
                          <tr>
                            <td><span class="tdcol1">Email</span><span>{item.email}</span></td>
                          </tr>
                          <tr>
                            <td><span class="tdcol1">Office #</span><span>{item.office}</span></td>
                          </tr>
                          <tr>
                            <td><span class="tdcol1">Cell #</span><span>{item.cell}</span></td>
                          </tr>
                          <tr>
                            <td><span class="tdcol1">Fax #</span><span>{item.fax}</span></td>
                          </tr>
                        </table>
                        
                      </div>

                    </div>
                    ) : ""}

                </div> </div>
              </div>
            </div>
          </div>
        </div>}
        <section id="playstoreBlock" className="playstoreBlock">
          <div className="container">
            <div className="row content">
              <div className="col-lg-12">
              <img src={appstore} />
			        <img src={googleplay} />
              </div>
            </div>
          </div>
        </section>
      </main>}
    </div>
  );
};

export default MeetStaff;